import script from "./CharityList.vue?vue&type=script&setup=true&lang=js"
export * from "./CharityList.vue?vue&type=script&setup=true&lang=js"

import "./CharityList.vue?vue&type=style&index=0&id=5c46758c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c46758c"]])

export default __exports__